import dayjs, { Dayjs } from 'dayjs';
import { CellBooking } from '../../../../types/meetingRoomTable';

import { getOccurrenceDate } from '../MeetingRoomCell/helpers';

const parseBookingTime = (booking: CellBooking, cellDate?: Dayjs): { start: Dayjs; end: Dayjs } => {
    const occurrenceDate = cellDate ? getOccurrenceDate(booking, cellDate) : booking.date;
    return {
        start: dayjs(`${occurrenceDate} ${booking.startTime}`),
        end: dayjs(`${occurrenceDate} ${booking.endTime}`),
    };
};

export const overlapsCell = (booking: CellBooking, cellStart: Dayjs, cellEnd: Dayjs): boolean => {
    const { start, end } = parseBookingTime(booking, cellStart);
    return start.isBefore(cellEnd) && end.isAfter(cellStart);
};

export const startsInCell = (booking: CellBooking, cellStart: Dayjs, cellEnd: Dayjs): boolean => {
    const { start } = parseBookingTime(booking, cellStart);
    return start.isSame(cellStart) || (start.isAfter(cellStart) && start.isBefore(cellEnd));
};

export const calculateMaxRowSpan = (bookings: CellBooking[]): number => {
    let maxSpan = 1;
    bookings.forEach((booking) => {
        const { start, end } = parseBookingTime(booking);
        const durationHours = end.diff(start, 'hours', true);
        // Use floor to get full hours that need to be spanned
        // Partial hours (e.g., 9:00-9:30) render inside the cell, not as a span
        const span = Math.max(1, Math.floor(durationHours));
        if (span > maxSpan) maxSpan = span;
    });
    return maxSpan;
};

export const getBookingRowSpan = (booking: CellBooking, cellStart: Dayjs): number => {
    const { start, end } = parseBookingTime(booking, cellStart);
    const durationHours = end.diff(start, 'hours', true);
    const hoursFromCellStart = cellStart.diff(start, 'hours', true);
    const remainingHours = durationHours - hoursFromCellStart;
    return Math.max(1, Math.floor(remainingHours));
};

export const endsInCell = (booking: CellBooking, cellStart: Dayjs, cellEnd: Dayjs): boolean => {
    const { end } = parseBookingTime(booking, cellStart);
    return end.isSame(cellEnd) || (end.isAfter(cellStart) && end.isBefore(cellEnd));
};
